import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import OffCanvas from "../../../OffCanvas/OffCanvas";
import { AiFillEye } from "react-icons/ai";

const TableSms = ({ mySMS }) => {
  const [smsDetails, setSMSDetails] = useState(null);
  const [isToggleView, setIsToggleView] = useState(false);
  const [windowWidth, setWindowWidth] = useState(
    typeof window !== "undefined" ? window.innerWidth : 1024
  );

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const isMobile = windowWidth < 768;
  const isSmallMobile = windowWidth < 480;

  const tog_viewSMS = (details) => {
    setSMSDetails(details);
    setIsToggleView(!isToggleView);
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const yyyy = date.getFullYear();
    const mm = String(date.getMonth() + 1).padStart(2, "0");
    const dd = String(date.getDate()).padStart(2, "0");
    return `${yyyy}-${mm}-${dd}`;
  };

  const formatTime = (dateString) => {
    const date = new Date(dateString);
    const hh = String(date.getHours()).padStart(2, "0");
    const mm = String(date.getMinutes()).padStart(2, "0");
    return `${hh}:${mm}`;
  };

  const customStyles = {
    tableWrapper: {
      style: {
        width: "100%",
        overflowX: "auto",
        WebkitOverflowScrolling: "touch",
      },
    },
    headRow: {
      style: {
        backgroundColor: "#f8f9fa",
        borderBottomWidth: "2px",
        borderBottomColor: "#e9ecef",
        minHeight: "48px",
      },
    },
    headCells: {
      style: {
        fontSize: isMobile ? "10px" : "12px",
        fontWeight: "700",
        color: "#495057",
        textTransform: "uppercase",
        letterSpacing: "0.5px",
        paddingLeft: isMobile ? "8px" : "12px",
        paddingRight: isMobile ? "8px" : "12px",
        whiteSpace: "nowrap",
      },
    },
    cells: {
      style: {
        fontSize: isMobile ? "11px" : "13px",
        color: "#212529",
        paddingLeft: isMobile ? "8px" : "12px",
        paddingRight: isMobile ? "8px" : "12px",
        minHeight: "60px",
      },
    },
    rows: {
      style: {
        "&:hover": {
          backgroundColor: "#f8f9fa",
        },
        borderBottomWidth: "1px",
        borderBottomColor: "#e9ecef",
      },
    },
    pagination: {
      style: {
        backgroundColor: "#ffffff",
        borderTopWidth: "1px",
        borderTopColor: "#e9ecef",
        minHeight: "52px",
        fontSize: "13px",
      },
    },
  };

  const columns = [
    {
      name: <span>Audience</span>,
      selector: (row) => row?.audience,
      sortable: true,
      grow: 2,
      style: {
        fontWeight: "600",
        fontSize: isMobile ? "12px" : "14px",
      },
      cell: (row) => (
        <div
          style={{
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            paddingRight: "8px",
          }}
          title={row?.audience}
        >
          {row?.audience || "N/A"}
        </div>
      ),
    },
    {
      name: <span>Message</span>,
      sortable: true,
      grow: 3,
      style: {
        fontSize: isMobile ? "11px" : "13px",
      },
      cell: (row) => {
        return (
          <div
            style={{
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              paddingRight: "8px",
              color: "#6b7280",
            }}
            title={row?.body}
          >
            {row?.body?.length > 0
              ? `${row?.body?.substring(0, 30)}...`
              : row?.body || "N/A"}
          </div>
        );
      },
    },
    {
      name: <span>Sent By</span>,
      sortable: true,
      style: {
        fontWeight: "600",
        fontSize: isMobile ? "11px" : "13px",
      },
      cell: (row) => {
        return (
          <div style={{ paddingRight: "8px", whiteSpace: "nowrap" }}>
            {row?.userId?.firstName || "N/A"}{" "}
            {row?.userId?.lastName?.charAt(0) || ""}
          </div>
        );
      },
    },
    {
      name: <span>Date</span>,
      selector: (row) => formatDate(row?.createdAt),
      sortable: true,
      style: {
        fontSize: isMobile ? "11px" : "13px",
      },
      cell: (row) => (
        <div style={{ paddingRight: "8px", whiteSpace: "nowrap" }}>
          {formatDate(row?.createdAt)}
        </div>
      ),
    },
    {
      name: <span>Time</span>,
      selector: (row) => formatTime(row?.createdAt),
      sortable: true,
      hide: isSmallMobile, // Hide on very small screens
      style: {
        fontSize: isMobile ? "11px" : "13px",
      },
      cell: (row) => (
        <div style={{ paddingRight: "8px", whiteSpace: "nowrap" }}>
          {formatTime(row?.createdAt)}
        </div>
      ),
    },
    {
      name: <span>View</span>,
      cell: (row) => {
        const buttonSize = isMobile ? 36 : 40;
        const iconSize = isMobile ? 16 : 20;

        return (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <button
              onClick={() => tog_viewSMS(row)}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: `${buttonSize}px`,
                height: `${buttonSize}px`,
                background: "#0d6efd",
                color: "#ffffff",
                border: "none",
                borderRadius: "6px",
                cursor: "pointer",
                transition: "all 0.2s ease",
                boxShadow: "0 2px 6px rgba(13, 110, 253, 0.35)",
                flexShrink: 0,
                padding: 0,
              }}
              title="View SMS"
              type="button"
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-2px)";
                e.currentTarget.style.boxShadow =
                  "0 4px 12px rgba(13, 110, 253, 0.4)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow =
                  "0 2px 6px rgba(13, 110, 253, 0.35)";
              }}
            >
              <AiFillEye size={iconSize} />
            </button>
          </div>
        );
      },
      center: true,
      minWidth: isMobile ? "80px" : "100px",
    },
  ];

  const data = mySMS || [];

  return (
    <div style={styles.container}>
      {data.length === 0 ? (
        <div style={styles.emptyState}>
          <div style={styles.emptyIcon}>📭</div>
          <h4 style={styles.emptyTitle}>No SMS found</h4>
          <p style={styles.emptyText}>
            Start by sending your first SMS message
          </p>
        </div>
      ) : (
        <div style={styles.tableWrapper}>
          <DataTable
            columns={columns}
            data={data}
            responsive
            pagination
            paginationPerPage={10}
            paginationRowsPerPageOptions={[10, 25, 50]}
            customStyles={customStyles}
            highlightOnHover
            noDataComponent={
              <div style={styles.noData}>No records to display</div>
            }
          />
        </div>
      )}

      <OffCanvas
        isOffcanvasOpen={isToggleView}
        title="SMS Details"
        body={
          <div>
            <div style={{ marginBottom: "16px" }}>
              <span style={{ fontWeight: "bold", color: "#6b7280" }}>
                To:{" "}
              </span>
              <span style={{ fontWeight: "600", color: "#111827" }}>
                {smsDetails?.audience}
              </span>
            </div>

            <div
              style={{
                padding: "16px",
                border: "1px solid #e5e7eb",
                backgroundColor: "#f9fafb",
                borderRadius: "8px",
                minHeight: "200px",
                fontSize: "14px",
                lineHeight: "1.6",
                color: "#374151",
              }}
            >
              {smsDetails?.body}
            </div>
          </div>
        }
        toggleSaveChanges={() => tog_viewSMS()}
        directionOffCanvas="end"
        widthOffCanvas={isMobile ? "100%" : 500}
      />

      <style>{`
        @media (max-width: 768px) {
          .sms-table-container {
            padding: 8px !important;
          }
        }

        @media (max-width: 480px) {
          .sms-table-container {
            padding: 4px !important;
          }
        }
      `}</style>
    </div>
  );
};

const styles = {
  container: {
    width: "100%",
    maxWidth: "100%",
    padding: "16px",
    boxSizing: "border-box",
    backgroundColor: "#ffffff",
  },
  emptyState: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: "60px 20px",
    minHeight: "250px",
    textAlign: "center",
  },
  emptyIcon: {
    fontSize: "48px",
    marginBottom: "16px",
  },
  emptyTitle: {
    margin: "0 0 8px 0",
    fontSize: "18px",
    fontWeight: "600",
    color: "#212529",
  },
  emptyText: {
    margin: 0,
    fontSize: "14px",
    color: "#6c7280",
  },
  tableWrapper: {
    width: "100%",
    overflowX: "auto",
    WebkitOverflowScrolling: "touch",
    borderRadius: "8px",
  },
  noData: {
    padding: "40px 20px",
    textAlign: "center",
    color: "#6c757d",
    fontSize: "14px",
  },
};

export default TableSms;